// @flow
import type { IConstraintModel } from "../../types";

/**
 */
class PasswordMinNumericCharactersConstraint implements IConstraintModel {
  _minNumeric: number;

  /**
   */
  constructor(minNumeric: number) {
    this._minNumeric = minNumeric;
  }

  /**
   */
  get id(): string {
    return "Constraint.Password.MinNumericCharactersMandatory";
  }

  /**
   */
  get minNumeric(): number {
    return this._minNumeric;
  }

  /**
   */
  hasValidation(): boolean {
    return true;
  }

  /**
   */
  get defaultMessage(): string {
    return "Must contain ${min-numeric} or more numerical characters"; // NOSONAR
  }

  /**
   */
  get parameters(): { "min-numeric": number } {
    return {
      "min-numeric": this.minNumeric,
    };
  }

  /**
   */
  validate(value: string): boolean {
    return value.replace(/\D/gu, "").length >= this.minNumeric;
  }

  /**
   */
  get isMandatoryConstraint(): boolean {
    return false;
  }
}

export default PasswordMinNumericCharactersConstraint;
